import { useEffect, useMemo, useRef } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { BACKGROUND_EFFECT_TYPE, CardFiled, ICardFieldValue, ILandingCanvas } from "src/modules/pe-landing-module/data/interfaces"
import { useIScroll } from "src/modules/pe-landing-module/hooks/useIScroll"
import FieldContent from "../FieldContent"

/* Protopia Ecosystem component */
export interface ICanvasFieldProps {
    field:CardFiled
    i: number
    data: ILandingCanvas
    value:ICardFieldValue
}
const CanvasField = ({data, field, value, i, ...props}: ICanvasFieldProps): JSX.Element => {
    const { isHidden, effect, parallax_speed, parallax_y_offset } = field
    const ref = useRef(null)
    const scroll  = useIScroll( ref, effect ) 
    const style = useMemo(() => {
        let st = { ...field.style }
        delete st.transform
        return st
    },[])
    
    useEffect(() => { 
        addCSSClass(
            `canvas-${ data.id }-${ i }`,
            `.canvas-outer-${ data.id }-${ i } { 

            }
            .canvas-inner-${ data.id }-${ i } { 
                
            }`
        ) 
        return () => {
            removeCSSClass(`canvas-${ data.id }-${ i }`)
        }
    },[])
    
    if(isHidden) return <></>

    let transform: string = "", poffset = 0
    switch ( effect ) {
        case BACKGROUND_EFFECT_TYPE.VERTICAL_PARALLAX: 
            poffset = scroll * ( parallax_speed || -0.1 ) - ( parallax_y_offset || -100 )
            break
        case BACKGROUND_EFFECT_TYPE.FIXED: 
            poffset = scroll - ( parallax_y_offset || 0 )
            break
        default: 
            poffset = 0
    }

    transform = `translateY(${ poffset }px)`
    
    return <div className={`pe-canvas-field-outer-container canvas-outer-${ data.id }-${ i }`} ref={ref}>
        <div 
            className={`pe-canvas-field-inner-container canvas-inner-${ data.id }-${ i }`}
            style={{
                transform
            }}
        >
            {/* 
            // Need primitive component
            <FieldContent 
                i={ i }
                data={ data as any }
                field={ {
                    ...field,
                    style : style
                } }
                value={ value }
            /> 
            */}
        </div>
    </div>
}
export default CanvasField